import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Point } from 'geojson';
import * as L from 'leaflet';
import { Observable } from 'rxjs';
import { NominatimResult } from './model/nominatim';

@Injectable({
  providedIn: 'root',
})
export class GeoCodingService {
  readonly url: string = 'https://geo.seatback.de/nominatim/search.php';
  readonly params: string = '?format=json&addressdetails=1&q=';
  readonly reqHeader = new HttpHeaders();

  constructor(private http: HttpClient) {}

  searchAddress(address: string): Observable<NominatimResult[]> {
    return this.http.get<NominatimResult[]>(this.url + this.params + address);
  }

  coordinatesToAddress(coordinates: { x: number; y: number; z?: number }): Observable<NominatimResult[]> {
    return this.http.get<NominatimResult[]>(this.url + this.params + coordinates.y + ',' + coordinates.x);
  }

  pointToAddress(point: Point): Observable<NominatimResult[]> {
    return this.http.get<NominatimResult[]>(this.url + this.params + point.coordinates[1] + ',' + point.coordinates[0]);
  }

  latLngToAddress(latLng: L.LatLng): Observable<NominatimResult[]> {
    return this.http.get<NominatimResult[]>(this.url + this.params + latLng.lat + ',' + latLng.lng);
  }
}
